var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 42,
    viewBox: "0 0 56 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_4123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.89543 0 0 0.895431 0 2V37.1716C0 38.9534 2.15428 39.8457 3.41421 38.5858L20.4142 21.5858C20.7893 21.2107 21 20.702 21 20.1716V2C21 0.89543 20.1046 0 19 0H2ZM37 0C35.8954 0 35 0.895431 35 2V37.1716C35 38.9534 37.1543 39.8457 38.4142 38.5858L55.4142 21.5858C55.7893 21.2107 56 20.702 56 20.1716V2C56 0.89543 55.1046 0 54 0H37Z",
    fill: "#097990"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_4123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.80e2cdb220028a2689d6c94654869838.svg";
export { ForwardRef as ReactComponent };